const TERRITORY_COLORS = ['#E53935', '#8E24AA', '#1E88E5', '#F4511E', '#039BE5', '#7CB342', '#FB8C00', '#00897B', '#D81B60'];

/** A territory keeps its colour by its place in the name-sorted list, on the map and in the list beside it. */
export function territoryColor(index: number) {
  return TERRITORY_COLORS[index % TERRITORY_COLORS.length];
}
